<template>
	<el-row class="mainOnebox">
		<!-- 标题 -->
		<el-row class="mainOnebox_title">
			<img src="@/assets/image/home/title_product.png">
		</el-row>
		<!-- 内容 -->
		<el-row class="mainOnebox_main">
			<router-link to="productAntiSilpStrip" tag="span">
				<div class="mainOnebox_main_list">
					<img src="@/assets/image/home/AntislipStrip.png">
					<span class="mainOnebox_main_list_name">Anti-slip Strip</span>
				</div>
			</router-link>
			<router-link to="productTactileIndicator" tag="span">
				<div class="mainOnebox_main_list">
					<img src="@/assets/image/home/TactileIndicator.png">
					<span class="mainOnebox_main_list_name">Tactile Indicator</span>
				</div>
			</router-link>
			<router-link to="productStairNosing" tag="span">
				<div class="mainOnebox_main_list">
					<img src="@/assets/image/home/StairNosing.png">
					<span class="mainOnebox_main_list_name">Stair Nosing</span>
				</div>
			</router-link>
			<router-link to="productTactilePaving" tag="span">
				<div class="mainOnebox_main_list">
					<img src="@/assets/image/home/PVCPaving.png">
					<span class="mainOnebox_main_list_name">Tactile Paving</span>
				</div>
			</router-link>
			<router-link to="productFRPProducts" tag="span">
				<div class="mainOnebox_main_list">
					<img src="@/assets/image/home/FRPProducts.png">
					<span class="mainOnebox_main_list_name">FRP Products</span>
				</div>
			</router-link>
			<router-link to="productAccessories" tag="span">
				<div class="mainOnebox_main_list">
					<img src="@/assets/image/home/Accessories.png">
					<span class="mainOnebox_main_list_name">Accessories</span>
				</div>
			</router-link>

		</el-row>
	</el-row>
</template>

<script>
	// import banner from './components/banner.vue';

	export default {
		components: {
			// banner:banner,
		},
		data() {
			return {

			}
		},
		methods: {

		},

	}
</script>

<style lang="less" scoped>
	.mainOnebox {
		background: url(~@/assets/image/home/home_bg1.jpg);

		.mainOnebox_title {
			width: 100%;
			text-align: center;

			img {
				margin-top: 5vw;
				margin-bottom: 4vw;
				width: 12.7%;
			}
		}

		.mainOnebox_main {
			max-width: 1530px;
			margin: 0 auto;
			height: auto;
			display: flex;
			align-items: center;
			justify-content: center;
			flex-direction: row;
			flex-wrap: wrap;

			.mainOnebox_main_list {
				width: 350px;
				height: auto;
				margin: 1vh 1.5vw;
				position: relative;
				border-radius: 20px;
				overflow: hidden;

				img {
					width: 350px;
					// height: 285px;
					position: relative;
				}

				.mainOnebox_main_list_name {
					position: absolute;
					bottom: 0;
					height: 44px;
					line-height: 44px;
					font-weight: 700;
					color: #fafafa;
					width: 350px;
					z-index: 999;
					left: 0;
					text-align: center;
					background-color: rgba(0, 0, 0, 0.5);
					font-size: 24px;
					transition: all 0.5s ease 0s;
				}

				.mainOnebox_main_list_name:hover {
					height: 285px;
					line-height: 258px;
					transition: all 0.5s ease 0s;
					font-size: 30px;
				}
			}

			.mainOnebox_main_list_none {
				width: 350px;
				height: 0px;
			}
		}
	}
</style>
